/** API route map: URLS.Controller.PtoClassCodes */
export const PtoClassCodes = {
      name: 'PtoClassCodes/',
      create: 'create',
      read: 'read',
      update: 'update',
      delete: 'delete',
      search: 'search',
};
